export default class Datas {
    index = -1;
    count = 1;
    digits = 0;
    autoplay = true;
    timeline = new gsap.timeline();
    constructor({ el }) {
        this.el = el;

        this.initialize();
    }
    initialize() {
        this.$data = this.el.querySelectorAll(".main-data")
        this.$labels = this.el.querySelectorAll(".label")
        this.$navs = this.el.querySelectorAll(".navigation .button")
        this.$button = this.el.querySelector(".helper .button")
        this.$button.classList.remove("disabled")
        this.count = this.$data.length
        
        this.$loader = this.el.querySelector(".loader")
        
        this.$thumbSpan = document.createElement("span");
        this.$thumbSpan.classList.add("thumb");
        this.$loader.appendChild(this.$thumbSpan);

        this.computeDataCounter(this.$data);
        
        this.setIndex(0);

        this.$navs[0].addEventListener("click", () => {
            this.previous()
            if (this.autoplay) {
                this.pendingNext()
            }
        })

        this.$navs[1].addEventListener("click", () => {
            this.next()
            if (this.autoplay) {
                this.pendingNext()
            }
        })

        this.$button.addEventListener("click", () => {
            if (this.autoplay) {
                this.timeline?.pause()
                this.autoplay = false;
                this.$button.classList.add("disabled")
            } else {
                this.timeline?.play()
                this.autoplay = true;
                this.$button.classList.remove("disabled")
            }
        })

        if (this.autoplay) {
            this.pendingNext();
        }
    }

    pendingNext() {
        this.timeline?.kill()

        this.timeline = new gsap.timeline({
            onComplete: () => {
                this.next()
                this.pendingNext()
            }
        });
        this.timeline
            .set(this.$thumbSpan, {
                xPercent: 0,
                opacity: 1
            })
            .to(this.$thumbSpan, {
                xPercent: 100,
                ease: "linear",
                duration: 5
            })
            .to(this.$thumbSpan, {
                opacity: 0
            })
    }

    setIndex(idx) {
        this.$labels[this.index]?.classList.add("hidden")
        this.animateCountersTo(this.$data[idx].textContent)
        this.$labels[idx].classList.remove("hidden")
        this.index = idx
        if (this.index === 0) {
            this.$navs[0].classList.add("disabled")
        } else {
            this.$navs[0].classList.remove("disabled")
        }
        if (this.index === this.count - 1) {
            this.$navs[1].classList.add("disabled")
        } else {
            this.$navs[1].classList.remove("disabled")
        }
    }
    previous() {
        if (this.index > 0) {
            this.setIndex(this.index - 1);
        }
    }
    next() {
        if (this.index < this.count - 1) {
            this.setIndex(this.index + 1);
        } else {
            this.setIndex(0);
        }
    }

    animateCountersTo(strNumber) {
        const unit = 0.8;
        let offsetX = 0
        console.log("strNumber", strNumber)
        this.digits.forEach((digit, idx) => {
            if (idx < strNumber.length) {
                const originY = gsap.getProperty(digit.children[0], "y") / unit - 1;

                const spans = digit.querySelectorAll('.wrapper > span');

                const value = Array.from(spans).findIndex(span => span.textContent === strNumber[idx])

                const offset = Math.abs(originY - value);
                gsap.to(digit.children[0], {
                    y: `${unit * (value + 1)}em`,
                    overwrite: true,
                    duration:Math.min(1, Math.max(offset * 0.15, .3))
                })
                gsap.to(digit, {
                    x: -offsetX,
                    overwrite: true,
                    duration:Math.min(1, Math.max(offset * 0.15, .3))
                })
                const currentHelper = Array.from(spans).find(span => span.textContent === strNumber[idx]).querySelector(".helper-digit")
                if (currentHelper) {
                    offsetX += currentHelper.parentElement.offsetWidth - currentHelper.offsetWidth
                }
                
            } else {
                gsap.to(digit.children[0], {
                    y: `0em`,
                    overwrite: true,
                    duration: 0.3
                })
                gsap.to(digit, {
                    x: 0,
                    overwrite: true,
                    duration: 0.3
                })
            }
        })
    }

    computeDataCounter(data) {
        this.$data[0]?.classList.add("hidden")
        const values = gsap.utils.toArray(data).map(el => el.textContent)

        this.digits = values.reduce((acc, cur) => {
            return cur.length > acc ? cur.length : acc;
        }, 0)

        const div = this.el.querySelector('.counters');

        const digits = [];
        const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string)

        for (let counters = 0; counters < this.digits; counters++) {
            const digit = document.createElement('div')
            digit.className = "digit";
            const wrapper = document.createElement('div')
            wrapper.className = "wrapper";

            for (let i = 0; i <= 9; i++) {
                const span = document.createElement('span');
                span.textContent = i;
                wrapper.appendChild(span);
            }
            for (let i = 0; i < values.length; i++) {
                
                if (values[i][counters] !== undefined && !isNumeric(values[i][counters])) {
                    const span = document.createElement('span');
                    const spanFlex = document.createElement('span');
                    spanFlex.classList.add("helper-digit")
                    span.appendChild(spanFlex);
                    spanFlex.textContent = values[i][counters];
                    wrapper.append(span)
                }
            }
            digit.append(wrapper);
            div.append(digit);
            digits.push(digit);
        }
        this.digits = digits;
    } 

    dispose() {

    }
}